module.exports = __webpack_public_path__ + "img/bhdz@3x.f60e28e7.png";